const reorderObjectKeys = <T extends Record<string, any>>(obj: T): T => (
  Object.keys(obj).sort().reduce<T>((newObj: T, key: keyof T) => {
    // eslint-disable-next-line no-param-reassign
    newObj[key] = obj[key];
    return newObj;
  }, {} as T));

export default reorderObjectKeys;
